import {Ecolors} from 'constant';
import * as htmlToImage from 'html-to-image';
import React, {useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Animated, StyleSheet, View} from 'react-native';
import {PanGestureHandler} from 'react-native-gesture-handler';
import Svg, {Path} from 'react-native-svg';
import {getUuid} from 'utils';
// import ViewShot from 'react-native-view-shot';

function DrawLine(p: {setIsVisible: (t: boolean) => void}, ref: any) {
  const viewshotRef = useRef<any>(null);
  const pan = useRef(new Animated.ValueXY()).current;
  const [stateLine, setStateLine] = useState<any>({});
  const currentPathId = useRef<string | null>(null);

  useImperativeHandle(ref, () => ({
    accept: (callback: (t: string) => void) => {
      try {
        const body: any = document.getElementById('View');
        htmlToImage.toPng(body).then(function (dataUrl) {
          callback(dataUrl);
        });
        return;
      } catch (error) {}
    },
    clear: () => {
      setStateLine({});
    },
  }));

  const onGestureEvent = Animated.event(
    [
      {
        nativeEvent: {
          x: pan.x,
          y: pan.y,
        },
      },
    ],
    {
      listener: (event: any) => {
        const x = event.nativeEvent.x;
        const y = event.nativeEvent.y;

        // Lazy init: Nếu chưa có ID (do onBegan chạy chậm), tạo luôn tại đây
        if (!currentPathId.current) {
          currentPathId.current = getUuid();
        }

        const activeId = currentPathId.current;

        setStateLine((a: any) => {
          return {
            ...a,
            [activeId]: [...(a?.[activeId] || []), {x, y}],
          };
        });
      },
      useNativeDriver: true,
    },
  );

  useEffect(() => {
    if (!!Object.keys(stateLine)?.length) {
      p.setIsVisible(true);
    } else {
      p.setIsVisible(false);
    }
  }, [stateLine]);

  const onEndStroke = () => {
    currentPathId.current = null; // Reset ID về null để nét sau không bị nối vào
  };

  return (
    <PanGestureHandler
      onBegan={() => {
        currentPathId.current = getUuid();
      }}
      onEnded={onEndStroke}
      onFailed={onEndStroke}
      onCancelled={onEndStroke}
      onGestureEvent={onGestureEvent}>
      <View nativeID="View" style={s.ff} ref={viewshotRef}>
        <Svg width={'100%'} height={'100%'}>
          {Object.keys(stateLine).map((item: any, index: number) => {
            const consvar = stateLine[item];
            if (!consvar || consvar.length < 1) return null;

            const d =
              `M${consvar[0].x} ${consvar[0].y} ` +
              consvar
                .slice(1)
                .map((p: any) => `L${p.x} ${p.y}`)
                .join(' ');

            return (
              <Path
                key={item}
                d={d}
                fill="none"
                stroke={Ecolors.textColor}
                strokeWidth="2"
              />
            );
          })}
        </Svg>
      </View>
    </PanGestureHandler>
  );
}

const s = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
  },
  ff: {
    flex: 1,
    backgroundColor: 'transparent',
  },
});
export default React.forwardRef(DrawLine);
